<div id="{{appName}}_maintenance_err">
    <div class="container page-not-found">
        <div class="row">
            <div class="col-12 error-message">
                <h2>Were're Sorry, this Page Is Currently Undergoing Maintenance.</h2>
            </div>
            <div class="col-12 error-message">
                <h2>Please check back soon!</h2>
            </div>
        </div>
        <div class="col-12 row">
            <div>
                <img alt="Maintenance-Page" class="cts-error-message" [src]="commonService.commonFiles['maintenance-image']">
            </div>
        </div>
    </div>
</div>